import React, { useRef } from 'react';
import PropTypes from 'prop-types';

const Magma = ({ userType, magmaToken, magmaUrl }) => {
  const iframeLoaded = useRef(false);
  const iframeRef = useRef();

  const sendToIframeMagma = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      iframeRef.current.contentWindow.postMessage(
        {
          type: 'SET_TOKEN',
          token: magmaToken,
          tokenUserType: userType,
        },
        `${magmaUrl}/${userType}`
      );
    }
  };

  const IframeWithScopeMagma = () => {
    const url = new URL(`${magmaUrl}/${userType}`);
    url.searchParams.append('scope', window.location.origin);
    const iframeUrl = url.toString();

    const handleIframeLoad = () => {
      iframeLoaded.current = true;
      if (magmaToken) {
        sendToIframeMagma();
      }
    };

    return (
      <iframe
        ref={iframeRef}
        src={iframeUrl}
        onLoad={handleIframeLoad}
        style={{
          height: 'calc(100% - 18px)',
          width: 'calc(100% - 5px)',
          border: 'none',
          borderRadius: '8px',
          margin: '5px 5px 5px 0',
        }}
        sandbox='allow-same-origin allow-scripts allow-forms allow-popups allow-downloads allow-modals allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation'
        allow='clipboard-write; clipboard-read'
      />
    );
  };

  return <div className='content'>{IframeWithScopeMagma()}</div>;
};

Magma.propTypes = {
  userType: PropTypes.string,
  magmaToken: PropTypes.string,
  magmaUrl: PropTypes.string,
};

export default Magma;
